import { cn } from '@/lib/cn';

const LOGO_SRC = '/assets/ChatGPT_Image_Jul_22,_2026,_09_18_32_PM.png';

interface BrandLogoProps {
  className?: string;
  alt?: string;
}

export function BrandLogo({ className, alt = 'UNIVIBE logo' }: BrandLogoProps): JSX.Element {
  return <img src={LOGO_SRC} alt={alt} className={cn('block h-auto w-auto object-contain', className)} />;
}
